import { GlobalSearchResult } from "@/api/williams/search";
import { queryKeys } from "../../queryKeys";
import { usePinCertificate, usePinWelder } from "../../welders/hooks";
import { usePinContractor } from "../../contractors/hooks";
import { usePinProject } from "../../projects/hooks";
import { usePinScope } from "../../scopeOfWork/hooks";
import { usePinTestEvent } from "../../testEvents/hooks";
import { useQueryClient } from "react-query";

export function usePinResult() {
  const pinProject = usePinProject();
  const pinScope = usePinScope();
  const pinEvent = usePinTestEvent();
  const pinWelder = usePinWelder();
  const pinCertificate = usePinCertificate();
  const pinContractor = usePinContractor();
  const queryClient = useQueryClient();

  function mutate(result: GlobalSearchResult) {
    switch (result.resultType) {
      case "Project":
        pinProject.mutate(result.id);
        break;
      case "Scope of Work":
        pinScope.mutate(result.id);
        break;
      case "Test Event":
        pinEvent.mutate(result.id);
        break;
      case "Welder":
        pinWelder.mutate(result.id);
        break;
      case "Certificate":
        pinCertificate.mutate(result.id);
        break;
      case "Contractor":
        pinContractor.mutate(result.id);
        break;
    }

    queryClient.invalidateQueries(queryKeys.search.all());
  }

  return { mutate };
}
